<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<p class="ellipsis" *ngIf="loading">Loading Data</p>
<ng-container *ngIf="!loading">
    <h2>Customer Information</h2>
    <fieldset>
        <div class="row">
            <div class="col-4 col-sm-2 col-lg-1 mvd_form-group">
                <customer-photo classes="mvd_photo" [customerNumberId]="disbursementSummary?.customerNumberId" [legacySequenceNumber]="disbursementSummary?.legacySequenceNumber"></customer-photo>
            </div>
            <div class="col-sm-5 mvd_form-group">
                <label>Name</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.nameDisplayValue}}" disabled />
            </div>
            <div class="col-sm-5 col-md-4 mvd_form-group">
                <label>Legacy Customer Number</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.legacyCustomerNumber}}" disabled />
            </div>
        </div>
        <div class="row" *ngIf="disbursementSummary?.financeDisbursementRequestTypeId == financeDisbursementRequestType.CheckDisbursement.id">
            <div class="col-md-6 mvd_form-group">
                <label>Mailing Address</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.addressDisplayValue}}" disabled />
            </div>
        </div>
    </fieldset>

    <h2>Disbursement Request Information</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-4 col-md-3 mvd_form-group">
                <label>Disbursement Request Number</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.financeDisbursementRequestId}}" disabled />
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Status</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.financeDisbursementRequestStatusTypeDisplayValue}}" disabled />
            </div>
            <div class="col-sm-3 col-md-2 mvd_form-group">
                <label>Created Date</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.createdDateDisplay}}" disabled />
            </div>
            <ng-container [ngSwitch]="disbursementSummary?.financeDisbursementRequestStatusTypeDisplayValue">
                <div class="col-sm-3 col-md-2 mvd_form-group" *ngSwitchCase="'Approved'">
                    <label>Approved Date</label>
                    <input class="mvd_form-control" value="{{disbursementSummary?.approvedDateDisplay}}" disabled />
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group" *ngSwitchCase="'Issued'">
                    <label>Updated Date</label>
                    <input class="mvd_form-control" value="{{disbursementSummary?.updatedDateDisplay}}" disabled />
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group" *ngSwitchCase="'Denied'">
                    <label>Updated Date</label>
                    <input class="mvd_form-control" value="{{disbursementSummary?.updatedDateDisplay}}" disabled />
                </div>
            </ng-container>
        </div>
        <div class="row">
            <div class="col-sm-3 mvd_form-group">
                <label>Disbursement Amount</label>
                <p-inputNumber mode="currency" currency="USD" [ngModel]="disbursementSummary?.amount" [ngModelOptions]="{standalone: true}" disabled placeholder="$0.00" />
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Refund Type</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.financeDisbursementRequestTypeDisplayValue}}" disabled />
            </div>
            <div *ngIf="fuelTaxDisbursement" class="col-sm-3 mvd_form-group">
                <label>Period</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.periodRangeDisplayValue}}" disabled />
            </div>
        </div>
        <div class="row" *ngIf="disbursementSummary?.financeDisbursementRequestStatusTypeDisplayValue == 'Issued'">
            <div class="col-sm-3 mvd_form-group">
                <label>Issued Date</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.issuedDateDisplay}}" disabled />
            </div>
            <div class="col-sm-3 mvd_form-group">
                <label>Check Number</label>
                <input class="mvd_form-control" value="{{disbursementSummary?.checkNumber}}" disabled />
            </div>
        </div>
        <ng-content></ng-content>
    </fieldset>
</ng-container>
